<template>
    <div>
        <v-layout class="wrap mb-4">
            <div v-for="(rus, i) in ru_filters" :key="i" class="mr-3"><a class="link-grey" @click="filter_ru(i, $event)">{{ rus.letter }}</a></div>
        </v-layout>
        <v-divider />
        <v-layout class="wrap my-4">
            <div v-for="(eng, i) in eng_filters" :key="i" class="mr-3"><a class="link-grey" @click="filter_eng(i, $event)">{{ eng.letter }}</a></div>
        </v-layout>
        <v-layout class="mt-5 wrap">
            <listCards :content="lang=='ru' ? ru_filters[current_filter].content : eng_filters[current_filter].content" />
        </v-layout>
    </div>
</template>

<script>
import listCards   from '@/components/view_blocks/Database/list_blocks/list_cards';
import roundButton   from '@/components/ui/buttons/buttons_icon/round_button';
import {mapGetters, mapMutations, mapActions} from 'vuex';
export default {
  components: {
    listCards,
    roundButton,
  },
  computed: {
    ...mapGetters('database/glossary', [
      'ru_filters',
      'eng_filters',
      'current_filter',
      'lang',
    ]),
  },
  mounted() {
    this.get_glossary();
  },
  methods: {
    ...mapMutations('database/glossary', [
      'FILTER_RU',
      'FILTER_ENG',
      'SET_GLOSSARY',
    ]),
    ...mapActions('database/glossary', [
      'get_glossary',
    ]),
    filter_ru(i, ev) {
      this.FILTER_RU(i);
      document.querySelectorAll('.link-grey').forEach((item)=>{
        if (item.classList.contains('glossary-active')) {
          item.classList.remove('glossary-active');
        }
      });
      ev.target.classList.add('glossary-active');
    },
    filter_eng(i, ev) {
      this.FILTER_ENG(i);
      document.querySelectorAll('.link-grey').forEach((item)=>{
        if (item.classList.contains('glossary-active')) {
          item.classList.remove('glossary-active');
        }
      });
      ev.target.classList.add('glossary-active');
    },
  },
};
</script>
<style lang="less" scoped>
.link-grey {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
}
.glossary-active {
  background-color: #44b69e;
  text-align: center;
  border-radius: 50%;
  color: #fff;
}
</style>
